import { responseStatus } from "../constants";
import { ApiPaths } from "../helpers/api";
import { ChiTietThanhLyTaiSan, ThanhLyTaiSanRequest, TimKiemThanhLyTaiSanRequest } from "../models/taisan/ThanhLyTaiSan";
import { TaiSan } from "../models/taisan/TaiSan";
import intance from "../utils/axios";

export const timKiemDSPhieuThanhLy = async (request: TimKiemThanhLyTaiSanRequest, start: number, length: number) => {
    let data = {
        data: [],
        recordsTotal: 0,
    };

    await intance.post(ApiPaths.thanhLyTaiSan.timKiem, {
        start,
        length,
        filter: {
            tuKhoa: request.tuKhoa || "",
            trangThai: request.trangThai,
            tuNgay: request.tuNgay,
            denNgay: request.denNgay,
        },
        orderBy: {
            columnName: "ngayLap",
            isDesc: true,
        }
    })
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });

    return data;
};

export const layChiTietPhieuThanhLy = async (id: number) => {
    let rs: ChiTietThanhLyTaiSan | null = null;

    await intance.get(`${ApiPaths.thanhLyTaiSan.layChiTiet}?id=${id}`)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });

    return rs;
};

export const layDanhSachTaiSanCoTheThanhLy = async () => {
    let rs: TaiSan[] = [];

    await intance.get(ApiPaths.thanhLyTaiSan.layDSTaiSan)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });

    return rs;
};

export const luuPhieuThanhLy = async (request: ThanhLyTaiSanRequest) => {
    let response = { trangThai: responseStatus.loi, thongBao: "", duLieu: 0 };
    const formData = new FormData();

    formData.append("id", (request.id || "").toString());
    formData.append("ngayLap", request.ngayLap || "");
    formData.append("noiDung", request.noiDung || "");
    formData.append("danhSachTaiSanJson", JSON.stringify(request.idsTaiSan || []));
    formData.append("idsTaiLieuThanhLyXoaJson", JSON.stringify(request.idsTaiLieuThanhLyXoa || []));

    request.files.forEach((file) => {
        const rawFile = file?.originFileObj || file;
        if (rawFile) {
            formData.append("files", rawFile);
        }
    });

    await intance.post(ApiPaths.thanhLyTaiSan.luuPhieu, formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    })
        .then((res) => {
            response = res.data;
        })
        .catch((err) => {
            throw err;
        });

    return response;
};




export const hoanThanhThanhLy = async (id: number) => {
    let response = { trangThai: responseStatus.loi, thongBao: "" };

    await intance.post(ApiPaths.thanhLyTaiSan.hoanThanh, JSON.stringify(id), {
        headers: {
            "Content-Type": "application/json"
        }
    })
        .then((res) => {
            response = res.data;
        })
        .catch((err) => {
            throw err;
        });

    return response;
};
